import React, { useState } from "react";
import FileUpload from "../../../util/FileUpload";

const SiteUpdate = ({ currentItem, onSubmit, onCancel, types }) => {
	const nameUpdate = React.createRef();
	const addressUpdate = React.createRef();
	const emailUpdate = React.createRef();
	const telNoUpdate = React.createRef();
	const websiteUpdate = React.createRef();
	const [logo, setLogo] = useState(null);

	const [id, setId] = useState(null);
	const [typeId, setTypeId] = useState(null);

	setTimeout(() => {
		if (currentItem) {
			setId(currentItem.id);
		}
		if (nameUpdate && nameUpdate.current) {
			nameUpdate.current.value = currentItem.name;
		}
		if (addressUpdate && addressUpdate.current) {
			addressUpdate.current.value = currentItem.address;
		}
		if (emailUpdate && emailUpdate.current) {
			emailUpdate.current.value = currentItem.email;
		}
		if (telNoUpdate && telNoUpdate.current) {
			telNoUpdate.current.value = currentItem.tel;
		}
		if (websiteUpdate && websiteUpdate.current) {
			websiteUpdate.current.value = currentItem.website;
		}
	});

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				onSubmit({
					name: nameUpdate.current.value,
					address: addressUpdate.current.value,
					email: emailUpdate.current.value,
					tel: telNoUpdate.current.value,
					website: websiteUpdate.current.value,
					type: typeId || currentItem.type.id,
					id,
					logo
				});
			}}
		>
			<div className="card">
				<div className="card-head">
					<header>
						<span>Update</span> {currentItem.name}
					</header>
				</div>
				<div className="card-body">
					<div className="form-body">
						<div className="form-group row">
							<label className="control-label col-md-4">
								Name
								<span className="required"> * </span>
							</label>
							<div className="col-md-8">
								<input
									type="text"
									name="name"
									ref={nameUpdate}
									data-required="1"
									required
									placeholder="Site name"
									className="form-control input-height"
								/>
							</div>
						</div>

						<div className="form-group row">
							<label className="control-label col-md-4">
								Email
								<span className="required"> * </span>
							</label>
							<div className="col-md-8">
								<input
									type="email"
									ref={emailUpdate}
									className="form-control input-height"
									name="email"
									required
									placeholder="Email Address"
								/>
							</div>
						</div>

						<div className="form-group row">
							<label className="control-label col-md-4">
								Mobile No.
								<span className="required"> * </span>
							</label>
							<div className="col-md-8">
								<input
									name="tel_number"
									type="text"
									ref={telNoUpdate}
									required
									placeholder="Mobile number"
									className="form-control input-height"
								/>
							</div>
						</div>

						<div className="form-group row">
							<label className="control-label col-md-4">
								Website
							</label>
							<div className="col-md-8">
								<input
									name="website"
									type="text"
									ref={websiteUpdate}
									placeholder="Website Address"
									className="form-control input-height"
								/>
							</div>
						</div>
						<div className="form-group row">
							<label className="control-label col-md-4">
								Site Type
								<span className="required">*</span>
							</label>
							<div className="col-md-8">
								<select
									className="form-control input-height"
									name="type"
									onChange={e => setTypeId(e.target.value)}
									defaultValue={currentItem.type.id}
								>
									<option>Select...</option>
									{types.map(x => {
										return (
											<option key={x.id} value={x.id}>
												{x.name}
											</option>
										);
									})}
								</select>
							</div>
						</div>
						<div className="form-group row">
							<label className="control-label col-md-4">
								Address
							</label>
							<div className="col-md-8">
								<input
									name="address"
									type="textarea"
									ref={addressUpdate}
									placeholder="Physical Address"
									className="form-control input-height"
								/>
							</div>
						</div>
						<div className="form-group row">
							<div className="col-md-8 offset-md-4">
								<FileUpload
									title="Select Logo"
									onData={({ path }) => setLogo(path)}
								/>
							</div>
						</div>
						<div className="text-center">
							<button
								type="button"
								className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle margin-right-10 btn-default"
								onClick={onCancel}
							>
								<i className="material-icons text-danger">
									cancel
								</i>{" "}
								Cancel
							</button>
							<button
								type="submit"
								className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
							>
								Update Changes{" "}
								<i className="material-icons">arrow_forward</i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};

export default SiteUpdate;
